// extracted by mini-css-extract-plugin
export var hackathonTitle = "index-module--hackathonTitle--26VoR";
export var name = "index-module--name--2rvi7";